













import { defineComponent, ref } from "@vue/composition-api";
import useSessionStorage from "@/hooks/useSessionStorage";
import { USER_SETTINGS } from "@/const";
import BaseButton from "@/components/BaseButton";
import BaseConfirm from "@/components/BaseConfirm";

export default defineComponent({
  name: "UnauthorizedAgeConfirm",

  components: { BaseButton, BaseConfirm },
  setup() {
    const { getUserSetting, setUserSetting } = useSessionStorage();

    const show = ref(!getUserSetting(USER_SETTINGS.AGE_CONFIRMED));
    const onOver18 = () => {
      setUserSetting(USER_SETTINGS.AGE_CONFIRMED, { ageConfirmed: true });
      show.value = false;
    };

    const onUnder18 = () => {
      window.location.replace("https://google.com");
    };
    return {
      show,
      onOver18,
      onUnder18,
    };
  },
});
